import { Col, Row } from "antd";
import React, { useEffect } from "react";
import CustomCard from "../../../../../components/Dashboard/CustomCard";
import { SettingOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { getData } from "../../../../../actions/apiCall";
import { constants } from "../../../../../constants/common";
import { MasterConfigs } from "../../../../../interfaces/entity";
import ReusableTable from "../../../../../components/TableComponent";
import SalarySlipComponent from "../../../../../components/SalaryComponent/SalarySlipComponent";
import DashboardLayout from "./DashboardLayout";
import HiringPipeline from "./HiringPipeline/HiringPipeline";
import CurrentVacancies from "./CurrentVacancies/CurrentVacancies";
import MasterComponent from "../../../../../components/Forms";
import CurrentOpenings from "../../../../Jobs/index"
import { currentOpeningsConfig } from "../../../../../entity/Jobs/currentOpeningsConfig";

const PreOnboardingDashboard = () => {
    const [totalCounts, setTotalCounts] = React.useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        getApplicantCount();
    }, []);

    const getApplicantCount = async () => {
        const counts = await dispatch(getData('/shortlistedCandidates/counts/of/status'));
        if (counts) {
            console.log(counts);
            setTotalCounts(counts.data);
        }
    }



    return <Row gutter={[16, 16]}>

        <Col span={24}>
            <DashboardLayout />
            <HiringPipeline />
            <CurrentVacancies />

        </Col>



        {/* 
        {totalCounts && Object.entries(totalCounts).filter(([key]) => key !== 'null').map(([key, value]: any) => <Col span={4}>
            <CustomCard
                icon={<SettingOutlined />}
                title={constants.PROFILE_STATUS_TEXT[key]}
                subtitle=""
                value={value}
            />
        </Col>)} */}
        <Col span={24}>
            <MasterComponent config={currentOpeningsConfig} />
        </Col>
    </Row>
}

export default PreOnboardingDashboard;